import { Component, Input, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { FocusTrapModule } from 'primeng/focustrap';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';

@Component({
    selector: 'app-info-overlay',
    templateUrl: './info-overlay.component.html',
    styleUrls: ['./info-overlay.component.scss'],
    standalone: true,
    imports: [TranslateModule, ButtonModule, OverlayPanelModule, FocusTrapModule],
})
export class InfoOverlayComponent {
    @ViewChild('infoOverlay') infoOverlay!: OverlayPanel;

    @Input({ required: true }) overlayId!: string;
    @Input({ required: true }) overlayAreaLabel!: string;

    @Input({ required: false }) iconSize: 'medium' | 'large' = 'medium';
    @Input({ required: false }) iconType: 'info' | 'question' = 'info';
}
